import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    overflow: hidden;
    body {
      margin: 0;
      width: 100%;
      height: 100%;
      position: fixed;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;  
      position: relative;
      font-family: kanit_light;
      font-size: 14px;
      color: #1A1A1A;
    }
     button {
      border: none; 
      &:focus {
        outline: none;
      }
    }
    input {
      &:focus {
        outline: none;
      }
    }
  }
  /* keep react-datepicker calendar above tables (sticky header z-index: 2) */
  #datepicker-portal {
    position: relative;
    z-index: 9999;
  }
  .react-datepicker-popper {
    z-index: 9999;
  }
`;
